// @avantia common-code
import { registerConfigurationAction } from '../config/registerClientConfig';

export interface HpIsQuoteJourneyRouteOptions {
  ignoreEmpty: boolean;
  ignoreSlash: boolean;
}

export interface HpRoutingHandler {
  getInitialRoute: (productId: string) => string;
  isJourneyRoute: (route: string, options?: HpIsQuoteJourneyRouteOptions) => boolean;
}

let routingHandler: HpRoutingHandler = createDefaultRoutingHandler();
let websiteEndpoint: string;

registerConfigurationAction((config) => {
  ({ websiteEndpoint } = config);
});

export function getRoutingHandler() {
  return routingHandler;
}

export function setRoutingHandler(handler: HpRoutingHandler) {
  if (handler) {
    routingHandler = handler;
  }
}

function createDefaultRoutingHandler(): HpRoutingHandler {
  return {
    isJourneyRoute: () => {
      // If this is true, then the current location.pathname will be used.
      // If this is false, then the initial route will be used.
      // Since we want to use the initial route, we return false.
      // The isJourneyRoute function is used by specific implementations (e.g. quote journey)
      return false;
    },
    getInitialRoute: () => {
      return `${websiteEndpoint}/`;
    }
  };
}
